module.exports = __webpack_public_path__ + "static/media/freshgrocer-downtimedollars-logo-loading.a6d8019b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshgrocer-downtimedollars-logo-loading.png
// module id = 358
// module chunks = 0